import {
  Team,
  TeamAndPublicDocumentBaseTypeFieldsFragment,
} from '@/graphql/generated/graphql'
import { useViewStore } from '../store'

type MakeRequired<T> = {
  [P in keyof T]-?: NonNullable<T[P]>
}

export type Theme = Pick<
  Team,
  | 'publicViewPrimaryColor'
  | 'publicViewSecondaryColor'
  | 'publicViewInstitutionName'
  | 'logoBase64'
  | 'faviconBase64'
> & {
  documentSeeType: string
  url: string
}

type RequiredTheme = MakeRequired<Omit<Theme, 'logoBase64' | 'faviconBase64'>> &
  Pick<Theme, 'logoBase64' | 'faviconBase64'>

const fakeTheme = {
  // primary: '#006ab2',
  // secondary: '#ff8f00',
  publicViewPrimaryColor: '#7EBF5E',
  publicViewSecondaryColor: '#17467F',
  publicViewInstitutionName: 'Universidade Modelo',
  logoBase64: undefined,
  faviconBase64: undefined,
  documentSeeType: 'Documento',
  url: '',
} as const satisfies Theme

export function useViewTheme(): Theme | undefined {
  const theme = useViewStore((s) => s.theme)

  return theme
}

export function useForcedViewTheme(): RequiredTheme {
  const theme = useViewStore((s) => s.theme)

  return {
    publicViewInstitutionName:
      theme?.publicViewInstitutionName || fakeTheme.publicViewInstitutionName,
    publicViewPrimaryColor:
      theme?.publicViewPrimaryColor || fakeTheme.publicViewPrimaryColor,
    publicViewSecondaryColor:
      theme?.publicViewSecondaryColor || fakeTheme.publicViewSecondaryColor,
    logoBase64: theme?.logoBase64 || fakeTheme.logoBase64,
    faviconBase64: theme?.faviconBase64 || fakeTheme.faviconBase64,
    documentSeeType: theme?.documentSeeType || fakeTheme.documentSeeType,
    url: theme?.url || fakeTheme.url,
  }
}

export const setTheme = (
  theme: TeamAndPublicDocumentBaseTypeFieldsFragment,
) => {
  useViewStore.setState((s) => {
    s.theme = {
      logoBase64: theme.team.logoBase64,
      faviconBase64: theme.team.faviconBase64,
      publicViewInstitutionName: theme.team.publicViewInstitutionName,
      publicViewPrimaryColor: theme.team.publicViewPrimaryColor,
      publicViewSecondaryColor: theme.team.publicViewSecondaryColor,
      documentSeeType: theme.documentSeeType,
      url: theme.url,
    }
  })
}
